import {
  ENDPOINT_ENDPOINT_MONOPALETTE_INFO_DEV,
  ENDPOINT_MONOPALETTE_INFO_PROD,
} from './urls';

export const MONOPALETTE_INFO_ENDPOINT =
  process.env.NODE_ENV !== 'production'
    ? `/ns/sm-supply/supply-manager${ENDPOINT_ENDPOINT_MONOPALETTE_INFO_DEV}`
    : ENDPOINT_MONOPALETTE_INFO_PROD;
